import { Country, State } from "country-state-city";

export const getCountryAndStateName = (countryCode, stateCode) => {
  const state = State.getStateByCodeAndCountry(stateCode, countryCode).name;
  const country = Country.getCountryByCode(countryCode).name;
  return { state, country };
};
